export enum TEST_IDS {
  OTP_BACK_BUTTON = "id_otp_back_button",
  OTP_ERROR_VIEW = "id_otp_error_view",
  OTP_EDIT_TEXT_BOX = "id_otp_edit_text_box",
  PHONE_NUMBER_TEXT_FIELD = "id_phone_number_text_field",
  GET_OTP_BUTTON = "id_get_otp_button"
}

export enum ACCESSIBILITY_LABEL {
  OTP_BACK_BUTTON = "OTP back button",
  OTP_ERROR_VIEW = "OTP error view",
  OTP_EDIT_TEXT_BOX = "OTP edit text box",
  PHONE_NUMBER_TEXT_FIELD = "Phone number text field",
  GET_OTP_BUTTON = "Get OTP button"
}
